import React from 'react';
// import PropTypes from 'prop-types';
import { Form, Input, Checkbox, Select } from 'antd';


const { Option } = Select;

const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  statusChecked,
  setStatusChecked,
  refData,
  children,
  ...restProps
}) => {
  let inputNode = null;
  switch (inputType) {
    case 'switch':
      inputNode = (
        <Checkbox
          onChange={(e) => {
            setStatusChecked(e.target.checked);
          }}
          defaultChecked={record.status === 1 ? true : false}
        />
      );
      break;
    case 'select':
      inputNode = (
        <Select>
          {refData &&
            refData.map((category) => (
              <Option value={category.id}>{category.name}</Option>
            ))}
        </Select>
      );
      break;
    default:
      inputNode = <Input />;
      break;
  }

  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{
            margin: 0,
          }}
          rules={[
            {
              required: true,
              message: `Please Input ${title}!`,
            },
          ]}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

export default EditableCell;
